import { lazy } from 'react';

/** One shared promise so all Suspense boundaries reuse the same network fetch + parse. */
const grafanaRechartsPanels = import('./grafanaRechartsPanels');

export const LazyMeritConnectivityChartPanel = lazy(() =>
    grafanaRechartsPanels.then((m) => ({ default: m.MeritConnectivityChartPanel }))
);
export const LazyLatencyChartPanel = lazy(() =>
    grafanaRechartsPanels.then((m) => ({ default: m.LatencyChartPanel }))
);
export const LazyPacketLossChartPanel = lazy(() =>
    grafanaRechartsPanels.then((m) => ({ default: m.PacketLossChartPanel }))
);
export const LazyBgpChartPanel = lazy(() =>
    grafanaRechartsPanels.then((m) => ({ default: m.BgpChartPanel }))
);
export const LazyTrafficLevelDualChartPanel = lazy(() =>
    grafanaRechartsPanels.then((m) => ({ default: m.TrafficLevelDualChartPanel }))
);
export const LazyTrafficVolumeChartPanel = lazy(() =>
    grafanaRechartsPanels.then((m) => ({ default: m.TrafficVolumeChartPanel }))
);
